export default __webpack_public_path__ + "static/media/smarttv.b9abda98.png";